import { DetailTabModel } from '@y42/feature/detail-view';

export const VisualizationDashboardTabs: DetailTabModel[] = [
  {
    path: 'overview',
    logo: 'assets/images/redirection-icons/chart-bar-light.svg',
    label: 'View',
    description: 'Analyze your data',
  },
];
